import React, {Component} from "react"
import {observable} from "mobx"
import {observer} from "mobx-react"
import styles from "./Header.module.css"
import bellusLogo from "./parts/img/bellus-logo.png"
import {ReactComponent as SignatureIcon} from "./parts/img/signature.svg"
import {LogoutButton} from "./parts/LogoutButton"
import {MenuButton} from "./parts/MenuButton"
import {HelpButton} from "./parts/HelpButton"
import {Model} from "Model"
import {getFullNameFromJsonData} from "../../helper/Methods"

type Screen = "mobileScreen" | "desktopScreen"

interface Props {
    onClickNavigation: (e?) => void
    model: Model
}

@observer
export class Header extends Component<Props, {}> {
    @observable
    private screen: "mobileScreen" | "desktopScreen" = "desktopScreen"

    private onChangeScreen() {
        if (window.innerWidth < 1400) {
            this.screen = "mobileScreen"
        } else {
            this.screen = "desktopScreen"
        }
    }

    public render() {
        const {onClickNavigation} = this.props
        const user = this.props.model?.user
        const jsonData = this.props.model?.document?.json_data || {}
        const fullName =
            getFullNameFromJsonData(jsonData) ||
            `${user?.firstName || ""} ${user?.lastName || ""}`.trim() ||
            (user?.email ? user.email.split("@")[0] : "Applicant")

        const nameParts = fullName.trim().split(/\s+/)
        const initials =
            nameParts.length >= 2
                ? `${nameParts[0].charAt(0)}${nameParts[nameParts.length - 1].charAt(
                      0
                  )}`.toUpperCase()
                : fullName
                ? fullName.slice(0, 2).toUpperCase()
                : "BA"

        const userEmail = jsonData?.email || user?.email || ""

        return (
            <header className={styles.root}>
                <div className={styles.sidebar}>
                    <div className={styles.buttonWrapper}>
                        <div className={styles.userInfoWrapper}>
                            {this.screen === "mobileScreen" && (
                                <MenuButton onClick={onClickNavigation} />
                            )}
                            <div className={styles.userBadge}>
                                <div className={styles.avatarCircle}>{initials}</div>
                                <span className={styles.userName}>{fullName}</span>
                                {userEmail && (
                                    <span className={styles.studentIdBadge}>{userEmail}</span>
                                )}
                            </div>
                        </div>
                        <div className={styles.actionsWrapper}>
                            {this.screen === "desktopScreen" && (
                                <HelpButton
                                    onClick={() => {
                                        console.log("Help button click")
                                    }}
                                />
                            )}
                            <LogoutButton
                                onClick={() => {
                                    console.log("logout click")
                                    this.props.model.signOut()
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.wrapper}>
                    <h1 className={styles.h1}>
                        <img src={bellusLogo} alt="bellus-logo" className={styles.logo} />
                    </h1>
                    <div className={styles.rightWrapper}>
                        <svg
                            className={styles.signatureIcon}
                            viewBox="0 0 24 24"
                            fill="currentColor">
                            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                            <path d="M21.71 4.04a1 1 0 0 0-1.42 0l-1.04 1.04 2.42 2.42 1.04-1.04a1 1 0 0 0 0-1.42zM12 14.75V17.5h2.75l7.04-7.04-2.75-2.75L12 14.75z" />
                        </svg>
                        <span className={styles.text}>APPLY TO BELLUS</span>
                    </div>
                </div>
            </header>
        )
    }

    componentDidMount() {
        this.onChangeScreen = this.onChangeScreen.bind(this)
        window.addEventListener("resize", this.onChangeScreen)
        this.onChangeScreen()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onChangeScreen)
    }
}
